import { render, staticRenderFns } from "./InfosetLegacy.vue?vue&type=template&id=3be8ea5e&scoped=true&"
import script from "./InfosetLegacy.vue?vue&type=script&lang=ts&"
export * from "./InfosetLegacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8ea5e",
  null
  
)

export default component.exports